import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {QueryGetStripePortalLinkArgs} from '../__generated__/resolvers-types';

export const GET_STRIPE_PORTAL_LINK_QUERY = gql`
  query GetStripePortalLink($returnUrl: String!) {
    getStripePortalLink(returnUrl: $returnUrl) {
      id
      return_url
      error
      url
    }
  }
`;
export default function useGetPortalLink() {
  const {
    data,
    loading,
    error,
    refetch: getPortalLink,
  } = useQuery<{getStripePortalLink: {url: string}}, QueryGetStripePortalLinkArgs>(GET_STRIPE_PORTAL_LINK_QUERY, {
    skip: true,
    variables: {returnUrl: ''},
  });

  return {
    getPortalLink: async (returnUrl: string) =>
      getPortalLink({
        returnUrl,
      }),
    data,
    loading,
    error,
  };
}
